import React from 'react';
import { motion } from 'framer-motion';
import { WordsPullUp, SectionLabel } from '@/components/animations';

const PARAS = [
  "I started as a computer engineer, became a licensed attorney, and built an audience of more than 6 million people creating at the intersection of technology, AI, and culture. Along the way, I’ve partnered with Meta, Samsung, Microsoft, Nvidia, and most major Fortune 500 tech brands.",
  "I’m also building The King Below, a dark fantasy saga ten years in the making.",
  "This is where all of it lives.",
];

/**
 * About — not a card. As the viewer comes to rest on the clean hero2 (the cliff
 * world, after the diorama has zoomed away), the text resolves into place over
 * a soft scrim for legibility.
 */
export const StoryCard = ({ active }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={active ? { opacity: 1 } : { opacity: 0 }}
    transition={{ duration: 0.9, ease: 'easeOut' }}
    className="relative w-[min(680px,90vw)] text-center sm:text-left"
    data-testid="story-card"
    style={{ textShadow: '0 2px 40px rgba(0,0,0,0.9)' }}
  >
    {/* soft legibility scrim — a blurred pool of shade, not a card */}
    <div
      className="pointer-events-none absolute -inset-x-20 -inset-y-16 rounded-[45%] bg-background/45 blur-3xl"
      aria-hidden="true"
    />
    <div className="relative">
      <SectionLabel>About</SectionLabel>
      <h2
        className="text-4xl sm:text-6xl text-cream leading-[1.04]"
        style={{ fontFamily: "'IM Fell English', serif" }}
      >
        <WordsPullUp text={"I’m Joe Urbinati."} active={active} />
      </h2>
      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={active ? { opacity: 1, y: 0 } : { opacity: 0, y: 14 }}
        transition={{ duration: 0.8, delay: 0.4, ease: 'easeOut' }}
        className="mt-2 font-serif italic text-xl sm:text-2xl text-cream/85"
      >
        A storyteller, lawyer, and engineer.
      </motion.p>
      <div className="mt-6 max-w-[42rem] space-y-4">
        {PARAS.map((p, i) => (
          <motion.p
            key={i}
            initial={{ opacity: 0, y: 12 }}
            animate={active ? { opacity: 1, y: 0 } : { opacity: 0, y: 12 }}
            transition={{ duration: 0.8, delay: 0.7 + i * 0.28, ease: 'easeOut' }}
            className="text-sm sm:text-lg leading-relaxed text-cream/80"
          >
            {p}
          </motion.p>
        ))}
      </div>
    </div>
  </motion.div>
);
